import paths from "../paths";
import { IConnectionListPayload, IConnectionListResult, IUserFollowPayload } from "./workflowInterface";
import { ProfileWorkflowClient } from "./profileWorkflowClient";


export const getUserConnectionListApi = async (
  config: IConnectionListPayload
): Promise<IConnectionListResult> => {
  try {
    const response = await ProfileWorkflowClient.get<IConnectionListResult>(
      paths.getConnectionList(config)
    );
    return response?.data ?? undefined;
  } catch (e) {
    console.error('Error getting Follow List Api', e);
    return { data: [] };
  }
};
